import options from './options';

const { name } = options;

export const curNormative = state => state.models[name].data;
export const curNormatives = state => state.models[name].list;
export const isNormativeLoading = state => state.models[name].loading;
